import { ProvidedBySimplyBusinessLogo } from "./ProvidedBySimplyBusinessLogo";

export function ProvidedBySB() {
  return (
    <div className="mobius-header__provided-by">
      Provided by <ProvidedBySimplyBusinessLogo />
    </div>
  );
}
